import React from 'react';
import { css } from '@emotion/react';
import linkifyIt from 'linkify-it';
import tlds from 'tlds';
import { useFormContext } from 'react-hook-form';
import { DefaultWidgetConfig } from '$/widget/src/interface';

const linkify = linkifyIt();
linkify.tlds(tlds);

enum CTAAlign {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

const getButtonWrapStyle = (align: CTAAlign): string => {
  // const additionalSpace = 100;
  switch (align) {
    case CTAAlign.Left:
      // margin-left: calc(min(1px, max(0px, 100% - 500px)) * ${additionalSpace});
      return `
        margin-left: 0;
        margin-right: auto;
      `;
    case CTAAlign.Right:
      // margin-right: calc(min(1px, max(0px, 100% - 500px)) * ${additionalSpace});
      return `
        margin-left: auto;
        margin-right: 0;
      `;
    default:
      return `
        margin-left: auto;
        margin-right: auto;
      `;
  }
};

const CTA = (props: any) => {
  const {
    isPublish = false,
    onlyCustomCta = false,
    defaultText,
    renderCTA,
    block,
    className,
    theme = {},
    ...otherProps
  } = props;
  const { watch } = useFormContext();
  const borderRadius = watch('themeSettings.borderRadius');
  const actionColor = watch('themeSettings.actionColor');
  const primaryColor = watch('themeSettings.primaryColor');
  const {
    blockProps, // eslint-disable-line no-unused-vars
    customStyleMap, // eslint-disable-line no-unused-vars
    customStyleFn, // eslint-disable-line no-unused-vars
    decorator, // eslint-disable-line no-unused-vars
    forceSelection, // eslint-disable-line no-unused-vars
    offsetKey, // eslint-disable-line no-unused-vars
    selection, // eslint-disable-line no-unused-vars
    tree, // eslint-disable-line no-unused-vars
    contentState,
    blockStyleFn, // eslint-disable-line no-unused-vars
    preventScroll, // eslint-disable-line no-unused-vars
    onlyCustomCTA, // eslint-disable-line no-unused-vars
    ...elementProps
  } = otherProps;

  const { text, url, align } = contentState.getEntity(block.getEntityAt(0)).getData();

  if (renderCTA) {
    return (
      <div
        {...elementProps}
        className='CTAButton'
        css={css`
          position: relative;
          padding: 0.75rem 0;
          ${isPublish
            ? ''
            : `
            user-select: all;
            cursor: pointer;
            > div {
              .ewebinar__ButtonText {
                user-select: all;
                &::selection {
                  background: transparent;
                }
              }
              * {
                pointer-events: none;
              }
            }
          `}
          ${getButtonWrapStyle(align)}
        `}
      >
        {renderCTA({
          url,
          isPublish,
          overrideWidgetConfig: (config: DefaultWidgetConfig): DefaultWidgetConfig => ({
            ...config,
            button: {
              ...config.button,
              btnText: text ?? defaultText,
            },
            ewebinar: {
              ...config.ewebinar,
              borderRadius: borderRadius ?? config.ewebinar.borderRadius,
              primaryColor: primaryColor ?? config.ewebinar.primaryColor,
              actionColor: actionColor ?? config.ewebinar.actionColor,
            },
          }),
          ...elementProps,
        })}
      </div>
    );
  }
  return null;
};

export default CTA;
